import { Link } from "react-router";
import { api } from "@/lib/api";
import { useQuery } from "@/lib/useQuery";
import type { EmailThread } from "@/lib/types";
import { ago } from "@/lib/format";
import { Button, Card, Loading, Empty, Tag } from "@/components/ui";

export function EmailsTab({ scope, onCompose }: { scope: { accountId?: string; partnerId?: string }; onCompose?: () => void }) {
  const id = scope.accountId ?? scope.partnerId ?? "";
  const q = scope.accountId ? `accountId=${scope.accountId}` : `partnerId=${scope.partnerId}`;
  const { data, loading } = useQuery<EmailThread[]>(`emails:${id}`, () => api.get<EmailThread[]>(`/inbox/threads?${q}&status=all`), [id]);
  return (
    <Card title="Email threads" actions={onCompose && <Button size="md" variant="primary" onClick={onCompose}>Email</Button>}>
      {loading && !data ? <Loading /> : (data ?? []).length === 0 ? <Empty>{scope.partnerId ? "No email linked to this partner yet. Mail from this partner's contacts or domain links here on its own; anything else can be linked from the inbox." : "No email on this account yet."}</Empty> : (
        <table className="table">
          <thead><tr><th>Subject</th><th>With</th><th>Messages</th><th>Last</th></tr></thead>
          <tbody>
            {(data ?? []).map((t) => (
              <tr key={t.id}>
                <td><Link to={`/inbox/${t.id}`} style={{ color: "var(--text)", fontWeight: t.unread ? 600 : 400 }}>{t.subject || "(no subject)"}</Link>{t.aiCategories[0] && <> <Tag color="neutral">{t.aiCategories[0].replace(/_/g, " ")}</Tag></>}</td>
                <td className="muted-2 small">{t.participants.join(", ")}</td>
                <td className="num muted">{t.messageCount}</td>
                <td className="muted small">{ago(t.lastMessageAt)} ago</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Card>
  );
}
